import { Skeleton } from "../ui/skeleton";

const TopSliderSkeleton = () => {
  const skeletonCount = 7;

  return (
    <div className="flex flex-col gap-4 mb-2">
      <div className="flex flex-row space-x-4">
        <Skeleton className="h-8 w-1/5" /> {/* Title */}
        <Skeleton className="h-8 w-1/12" /> {/* Subtitle */}
      </div>
      <div className="flex gap-4">
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <div
            key={index}
            className="max-w-[220px] min-w-[200px] w-full gap-5 items-center flex whitespace-break-spaces border-gray7 rounded-10 border-2 py-[15px] pl-[22px] pr-[15px] lg:py-[11px] lg:px-[15px] bg-white lg:gap-[15px] lg:max-w-[150px] lg:min-w-[150px]"
          >
            {/* Image Skeleton */}
            <Skeleton className="h-[50px] w-[50px] lg:h-[40px] lg:w-[40px] rounded-md" />

            {/* Text Skeleton */}
            <div className="flex-1">
              <Skeleton className="h-4 w-3/4 mb-2" />
              <Skeleton className="h-4 w-1/2" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopSliderSkeleton;